import React, {useEffect} from 'react'
import './Bmc.css'
import Androidscreenshoot from '../images/Bmc/Androidscreenshoot.png'
import Artboard1 from '../images/Bmc/Artboard1.jpg'
import Artboard2 from '../images/Bmc/Artboard2.jpg'
import Artboard3 from '../images/Bmc/Artboard3.jpg'
import Artboard4 from '../images/Bmc/Artboard4.jpg'
import Artboard5 from '../images/Bmc/Artboard5.jpg'
import Artboard6 from '../images/Bmc/Artboard6.jpg'
import Artboard7 from '../images/Bmc/Artboard7.jpg'

import Artboard9 from '../images/Bmc/Artboard9.jpg'
import Artboard10 from '../images/Bmc/Artboard10.jpg'

import Footer from '../Component/footer'

function Bmc() {
    useEffect(() => {
        window.scroll(0, 0);
        document.body.scrollTop = 0;
    }, []);
    return (
        <div>
       
        <div className="imagevh" id="imageAndroidscreenshoot"><img src={Androidscreenshoot} height="" width="100%" alt=""/></div>
        
        <div className="project-details-Bmc">
        <div className="client-role-Bmc">
            <h4 className="client-project-Bmc">CLIENT</h4>
            <h2 className="portfolio-heading-Bmc1"> BosworthMc</h2>
            <h4 className="role-Bmc">
            ROLE
            </h4>
            <h2 className="portfolio-role-Bmc2">Ui/Ux Development</h2>
           </div>
            <h4 className="client-details-Bmc"> DETAILS
            </h4>
            <p className="client-details-Bmc-p">
            We are Bosworth Marketing Consulting, a ‘through the line’ marketing agency, with our core 
            business being events management and experiential marketing.
            </p>

            <p className="client-details-Bmc-p2">
           Our staff structure is a small core unit of permanent staff supplemented by first-rate 
consultants and a large database of tried and tested contract staff. We work closely as a team 
with our clients to implement according to their specifications.
            </p>
         </div>


         <div className="imagevh" id="artboard"><img src={Artboard1} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard2} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard3} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard4} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard5} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard6} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard7} height="auto" width="100%" alt=""/></div>
       
         <div className="imagevh" id="artboard"><img src={Artboard9} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard10} height="auto" width="100%" alt=""/></div>
         
     <div className="imagevh" id="artboard" ><Footer /></div> 

        </div>
        
    )
}

export default Bmc
